export const SET_GIVE_AWAY_WINNER_1 = 'giveAway/SET_GIVE_AWAY_WINNER_1';
export const SET_GIVE_AWAY_WINNER_2 = 'giveAway/SET_GIVE_AWAY_WINNER_2';
export const SET_GIVE_AWAY_WINNER_3 = 'giveAway/SET_GIVE_AWAY_WINNER_3';
